export default __webpack_public_path__ + "static/media/cvc.d776f3ab.svg";